import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  Modal,
  Slide,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useRef, useState } from 'react';
import { getLlmMapperData } from "../../../api's/ClusterAPI";
import LlmMapperAILoader from '../../../reusable-component/loader/LlmMapperAILoader';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import generateAlias from '../../../utils/generateAlias';
import { FETCH_SCHEMA } from '../../../utils/NodeModalContants';
import LlmMapperFlow from '../LlmMapperFlow';
import { nodeConfigs } from '../NodesSection';

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const NodeModalLlmMapper = ({
  nodeId,
  nodeName,
  handleClose,
  open,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  dataModel = false,
  dataModelformField,
  setDataModelformField = () => {},
  targetSchema = [],
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const INITIALSTATE = {
    action: '',
    persist: false,
    df: '',
    alias: generateAlias(nodeName, nodeId),
    persist_type: '',
    db_name: '',
    statement: '',
    distinct_rows: false,
    mappings: [],
    sample_view: true,
  };

  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [sourceColumns, setSourceColumns] = useState([]);
  const [targetColumns, setTargetColumns] = useState([]);
  const [llmLoader, setLlmLoader] = useState(false);
  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);
  const readBlocks = nodeConfigs?.Read;

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  console.log('source: ', sourceColumns);
  console.log('target: ', targetColumns);

  // useEffect(() => {
  //   setSourceColumns(sourceData);
  // }, [sourceData]);

  // const latestStateRef = useRef({
  //   formField,
  //   targetColumns,
  //   sourceColumns,
  // });

  // useEffect(() => {
  //   if (dataModel) {
  //     latestStateRef.current = { formField, targetColumns, sourceColumns };
  //   }
  // }, [formField, targetColumns, sourceColumns]);

  // useEffect(() => {
  //   console.log('inside useeffect ');
  //   if (dataModel) {
  //     const { formField, targetColumns, sourceColumns } = latestStateRef.current;
  //     setDataModelformField((prev) => ({
  //       ...prev,
  //       llmMapper: {
  //         nodeId,
  //         nodeName,
  //         formField,
  //         targetColumns,
  //         sourceColumns,
  //         mappings: formField.mappings,
  //         step_name: nodeName,
  //       },
  //     }));
  //   }
  // }, [dataModel]);

  console.log('formField: ', formField);

  const getLocalData = () => {
    if (dataModel) {
      setFormField((prev) => {
        return {
          ...prev,
          nodeId,
          nodeName,
          targetColumns,
          sourceColumns,
          step_name: nodeName,
          df: dataModelformField?.source?.formField?.alias,
        };
      });
      return;
    }
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      const source_columns_list = [];
      const target_columns_list = [];

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_nodeName = node.step_name;
            if (node.nodeName !== FETCH_SCHEMA.nodeModalTitle) {
              prev_alias = node.formField.alias;
            }
            if (readBlocks.some((block) => block.label === node.nodeName || block.key === node.nodeName)) {
              source_columns_list.push(...node.fetchedHeader);
            }
            if (node.nodeName === FETCH_SCHEMA.nodeModalTitle) {
              target_columns_list.push(...node.fetchedHeader);
            }
          }
        });
      });
      setSourceColumns(source_columns_list);
      setTargetColumns(target_columns_list);
      // setSourceColumns(source_columns_list.map((item) => ({ columnName: item.header, dataType: cast_datatype })));
      // setTargetColumns(target_columns_list.map((item) => ({ columnName: item.header, dataType: cast_datatype })));
      setFormField({ ...formField, df: prev_alias });

      const newArr = [];
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      //
      const head = [];
      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setFetchedHeader(newHeader);

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  // Executes at start
  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  const fetchLlmMapperDataByAI = async () => {
    setLlmLoader(true);
    try {
      const payload = {
        sourceColumns: sourceColumns.map((item) => ({ name: item.header, type: item.cast_datatype })),
        targetColumns: targetColumns.map((item) => ({ name: item.header, type: item.cast_datatype })),
      };

      const response = await getLlmMapperData(payload);
      if (response.status === 200) {
        const updatedData = [...response.data];
        const columnExists = (header) => {
          return updatedData.some((item) => item.destination_column.name === header);
        };
        targetColumns.forEach(({ header, cast_datatype }) => {
          if (!columnExists(header)) {
            updatedData.push({
              source_columns: [
                {
                  name: '',
                  type: '',
                },
              ],
              destination_column: {
                name: header,
                type: cast_datatype,
              },
            });
          }
        });

        setFormField({
          ...formField,
          mappings: updatedData,
        });
      }
    } catch (error) {
      console.log(error);
      setLlmLoader(false);
      enqueueSnackbar('Error while fetching data from LLM', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLlmLoader(false);
  };

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;
      const source_columns_list = [];
      const target_columns_list = [];

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_nodeName = node.step_name;
            if (node.nodeName !== FETCH_SCHEMA.nodeModalTitle) {
              prev_alias = node.formField.alias;
            }
            if (readBlocks.some((block) => block.label === node.nodeName)) {
              source_columns_list.push(...node.headerName);
            }
            if (node.nodeName === FETCH_SCHEMA.nodeModalTitle) {
              target_columns_list.push(...node.headerName);
            }
          }
        });
      });
      setSourceColumns(source_columns_list);
      setTargetColumns(target_columns_list);
      // setSourceColumns(source_columns_list.map((item) => item.header));
      // setTargetColumns(target_columns_list.map((item) => item.header));

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      //
      const head = [];
      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }

    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    value = e.target.value;

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    fetchedHeader.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];
    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const sendFormData = {
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      y_axis,
      headerName: newHeaderName,
      fetchedHeader,
      mappings: formField.mappings,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);
    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const content = (
    <div style={{ margin: '20px' }}>
      {llmLoader ? (
        <LlmMapperAILoader text={`${llmLoader ? 'Generating By AI' : ''}`} stars={llmLoader} />
      ) : (
        sourceColumns &&
        targetColumns && (
          <LlmMapperFlow
            fetchLlmMapperDataByAI={fetchLlmMapperDataByAI}
            setFormField={setFormField}
            formField={formField}
            sourceColumns={sourceColumns}
            targetColumns={targetColumns}
            disableForm={disableForm}
          />
        )
      )}
    </div>
  );

  return dataModel ? (
    <div>
      {content}
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  ) : (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={!disableForm}
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          {content}
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModalLlmMapper;
